export default __webpack_public_path__ + "static/media/password-edit4.ed645b53.png";